export default __webpack_public_path__ + "static/media/before-trip-1.55615cc0.svg";